const script = {
  saved: '话术已保存',
  created: '话术模板已创建',
  col_updated: '更新',
  col_created: '创建',
  actions: '操作',
  title: '话术',
  detail_title: '话术详情',
  detail_load_failed: '话术详情加载失败',
  detail_empty: '暂无话术详情',
  variables: '占位符',
  load_failed: '话术列表加载失败',
  shop_required: '请先选择店铺',
  create_failed: '话术模板创建失败',
  update_failed: '话术模板保存失败',
  delete_failed: '话术模板删除失败',
  delete_success: '话术模板已删除',
  delete_confirm: '确认删除话术「{{name}}」？删除后不可恢复。',
  new_template: '新建模板',
  ds_generate: 'DS 生成',
  generated_name: 'DS 生成 · {{point}}',
  generated: '已生成，确认后保存为模板',
  channel_dm: '私信',
  channel_email: '邮件',
  name_required: '请填写话术名称',
  content_required: '请填写话术正文',
  edit_title: '编辑话术',
  new_title: '新建话术',
  name: '名称',
  name_placeholder: '如：新品试样 · 美妆',
  channel: '渠道',
  subject: '主题',
  subject_placeholder: '邮件主题，可不填',
  body: '正文',
  body_placeholder: 'Hi {{token}}，我们有一款适合你粉丝的新品…',
  points_required: '请填写提示词',
  generate_failed: '生成失败，请稍后重试',
  generate_title: '生成话术',
  generate: '生成',
  name_hint: '期望名称',
  name_hint_placeholder: '如：新品试样 · 美妆',
  selling_points: '提示词',
  points_placeholder: '美妆新品试样邀约，语气亲切简短'
};

export default script;
